import { render, staticRenderFns } from "./jingjialiebiao.vue?vue&type=template&id=4043c390&scoped=true"
import script from "./jingjialiebiao.vue?vue&type=script&lang=js"
export * from "./jingjialiebiao.vue?vue&type=script&lang=js"
import style0 from "./jingjialiebiao.vue?vue&type=style&index=0&id=4043c390&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4043c390",
  null
  
)

export default component.exports